import {axiosInstance} from "../../../config/axiosInstance";
import {CONSTANTS} from "../../../constants/constants";

const API_VERSION = CONSTANTS.API.API_VERSION.V1

export const HOTEL_API = {
  setSearchHotel: async ({city, latitude, longitude, radius, categoryId, checkin, checkout, currency}) => (
    await axiosInstance.post(
      `${API_VERSION}/hotel/searchHotel`,
      {city, latitude, longitude, radius, categoryId, checkin, checkout, currency}
    )
  ),
}